import { useContext, useEffect } from "react";
import { apiClient } from "src/api/apiService";
import { AppContext } from "src/context/AppContext";
import { useAuth0 } from "../useAuth";

export const useLoginUserEffect = () => {
  const { isAuthenticated } = useAuth0();
  const { setContext } = useContext(AppContext);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await apiClient.get("/user/loginUser");
        setContext({ user: response.data });
      } catch (error) {
        console.error("Error getting user", error);
      }
    };
    if (isAuthenticated) {
      fetchUser();
    }
  }, [isAuthenticated]);
};
